import { render, staticRenderFns } from "./PixInfractions_Details.vue?vue&type=template&id=241cc4db&scoped=true"
import script from "./PixInfractions_Details.vue?vue&type=script&lang=ts"
export * from "./PixInfractions_Details.vue?vue&type=script&lang=ts"
import style0 from "./PixInfractions_Details.vue?vue&type=style&index=0&id=241cc4db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241cc4db",
  null
  
)

export default component.exports